import { TripStep } from "../../interfaces/trip-step.interface"
import { TripStepDetailsPublicTransport } from "../../interfaces/trip-step-details-public-transport.interface"
import { isDefined } from "../is-defined"

export const isPublicTransport = (
  step: TripStep
): step is TripStep<TripStepDetailsPublicTransport> =>
  isDefined((step.details as TripStepDetailsPublicTransport).stops)
